import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: sessionStorage.getItem("user")
    ? {
        ...JSON.parse(sessionStorage.getItem("user")),
        lastActiveTime: Date.now(),
      }
    : { lastActiveTime: Date.now() },
  reducers: {
    setUser: (state, action) => {
      state.Token = action.payload.Token;
      state.id = action.payload.id;
      state.Username = action.payload.Username;
      state.Name = action.payload.Name;
      state.Rol = action.payload.Rol;
      state.lastActiveTime = Date.now(); // Actualiza la hora de última actividad en el estado del usuario.
      sessionStorage.setItem(
        "user",
        JSON.stringify({
          ...action.payload,
          lastActiveTime: state.lastActiveTime, // También actualiza la hora de última actividad en la sesión.
        })
      );
    },
    logOut: (state) => {
      const timeActive = Date.now() - state.lastActiveTime; // Calcula el tiempo que el usuario ha pasado activo.
      // Almacena el tiempo activo en algún lugar para su uso futuro.
      const hours = Math.floor(timeActive / 3600000);
      const minutes = Math.floor((timeActive % 3600000) / 60000);
      const seconds = Math.floor((timeActive % 60000) / 1000);

      console.log(
        `El usuario ha pasado ${hours} horas, ${minutes} minutos y ${seconds} segundos activo en la aplicación.`
      );

      delete state.Token;
      delete state.Username;
      delete state.Name;
      delete state.Rol;
      delete state.id;
      delete state.lastActiveTime; // Elimina la propiedad de última hora activa del estado del usuario.
      sessionStorage.clear();
    },
  },
});

export const { setUser, logOut } = userSlice.actions;

export const selectUser = (state) => state.user;
export const selectAuth = (state) => state.user.Token;

export default userSlice.reducer;
